var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11894",
    "data-name": "Group 11894",
    transform: "translate(-1177 -223)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "translate(1177 223)",
    fill: "#f4f8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "report_FILL0_wght700_GRAD0_opsz48",
    d: "M18.36,51.335,4.75,37.726V18.31L18.36,4.7H37.776l13.61,13.61V37.726l-13.61,13.61Zm9.678-10.222a2.788,2.788,0,0,0,2.782-2.782,2.781,2.781,0,0,0-.817-2,2.705,2.705,0,0,0-3.932,0,2.781,2.781,0,0,0-.817,2,2.788,2.788,0,0,0,2.782,2.782ZM25.86,32.645h4.355V14.62H25.86Zm-5.141,13H35.356L45.639,35.367V20.729L35.356,10.446H20.719L10.436,20.729V35.367ZM28.038,28.048Z",
    transform: "translate(1197.688 242.3)",
    fill: "#107a98"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorManagement);
export default __webpack_public_path__ + "static/media/errorManagement.e55673922cf37ffca483803e13d329ca.svg";
export { ForwardRef as ReactComponent };